import React, {Component} from 'react';
import accordeonStyle from '../css/accordion.css';

class MultiTab extends Component {
    constructor(props) {
        super(props);
    }

    _executeScroll(reference) {
        reference.current.scrollIntoView({behavior: 'smooth', block: 'start'});
    }

    render() {
        let content = this.props.content;
        return (
            <div className={`${accordeonStyle.accordeon} ${accordeonStyle.accordionBorder}`}>
                <div className={`${accordeonStyle.title} ${accordeonStyle.multitab}`}>
                    {
                        this.props.tabs.map((tab, index) =>
                            <div className={accordeonStyle.subTab} key={index}
                                 onClick={() => this._executeScroll(tab.scrollRef)}>
                                <div className={accordeonStyle.tab}>
                                    {tab.name}
                                </div>
                            </div>)
                    }
                </div>
                <div>
                    {content}
                </div>
            </div>
        );
    }
}

export default MultiTab;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/containers/multitab.js